import React from "react";

import {
  RESOURCE_TYPES,
  DATA_CLASSIFICATIONS
} from "../constants/enums";

export default function ResourceScopeEditor({
  resourceScope = {
    resourceType: RESOURCE_TYPES[0],
    resourceName: "",
    classification: DATA_CLASSIFICATIONS[0],
    filters: []
  },
  onChange
}) {

const updateField = (field, value) => {

  onChange({
    ...(resourceScope || {}),
    [field]: value
  });

};

  return (

        <div className="form-section">

        <h3 className="section-title">
        Resource Scope
        </h3>

      <div className="form-group">

       <label className="form-label">

          Resource Type

        </label>

        <select
          className="form-input"
          value={
            resourceScope.resourceType ||
            RESOURCE_TYPES[0]
          }
          onChange={(e) =>
            updateField(
              "resourceType",
              e.target.value
            )
          }
        >

          {

            RESOURCE_TYPES.map(type => (

              <option
                key={type}
                value={type}
              >
                {type}
              </option>

            ))

          }

        </select>

      </div>

      <div className="form-group">

        <label className="form-label">

          Resource Name

        </label>

        <input
          className="form-input"
          value={
            resourceScope.resourceName || ""
          }
          onChange={(e) =>
            updateField(
              "resourceName",
              e.target.value
            )
          }
        />

      </div>

      <div className="form-group">

        <label className="form-label">

          Classification

        </label>

        <select
          className="form-input"
          value={
            resourceScope.classification ||
            DATA_CLASSIFICATIONS[0]
          }
          onChange={(e) =>
            updateField(
              "classification",
              e.target.value
            )
          }
        >

          {

            DATA_CLASSIFICATIONS.map(c => (

              <option
                key={c}
                value={c}
              >
                {c}
              </option>

            ))

          }

        </select>

      </div>

    </div>

  );

}